export default "__VITE_PUBLIC_ASSET__815e7d1d__"